var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AbilityConfig } from '../ability-config/ability-config';
import { PlatformLocation } from '@angular/common';
import { TokenService } from '../tokenService.service';
var CaseExecutiveListComponent = (function () {
    function CaseExecutiveListComponent(commonService, platformLocation, apiService, route, tokenService, router) {
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.apiService = apiService;
        this.route = route;
        this.tokenService = tokenService;
        this.router = router;
        this.showMoment = false;
        //进入新能力考核标识
        this.version = 0;
        this.isOpenClass = 0;
        this.isShowQuestionnaire = false;
        this.questionnaireInfo = null;
        this.approachTheme = {};
        this.currentIndex = 0;
        this.isShowApproach = false;
        this.isCustomLock = false;
        this.lock = false;
        this.isShowToast = false;
        this.isTencent = false; //是否为腾讯对接
    }
    Object.defineProperty(CaseExecutiveListComponent.prototype, "showGoToSurveyBtn", {
        get: function () {
            if (Array.isArray(this.practiceList)) {
                return this.practiceList.every(function (item) {
                    return item.status === 2;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    CaseExecutiveListComponent.prototype.ngOnInit = function () {
        var _this = this;
        // if(!localStorage.getItem('openClass')){
        //   this.isOpenClass = this.platformLocation['location']['href'].indexOf('isShowBack') > -1 ? 1: 0;
        //   localStorage.setItem('openClass',String(this.isOpenClass));
        // }else{
        //   this.isOpenClass = Number(localStorage.getItem('openClass'));
        // }
        // 添加是否腾讯对接的判断
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🍕🍕🍕🍕🍕🍕');
        // -------------------------------------------------------------------
        localStorage.setItem('moduleId', '3');
        this.route.params.subscribe(function (params) {
            var isOutLink = Number(params['isOutLink']);
            if (_this.platformLocation['location']['href'].indexOf('isShowBack') !== -1 || isOutLink === 1) {
                localStorage.setItem('openClass', '1');
            }
            else {
                localStorage.removeItem('openClass');
            }
            _this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        });
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.projectId = localStorage.getItem('projectId');
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 4 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        this.getPracticeList();
    };
    //获取进度
    CaseExecutiveListComponent.prototype.getProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    CaseExecutiveListComponent.prototype.getPracticeList = function () {
        var _this = this;
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        this.route.params.subscribe(function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var LearningTour, _a, LearningPathMetaId, _b, progerss, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.exerciseMetaId = params['exerciseMetaId'];
                        return [4 /*yield*/, this.getLearningTour()];
                    case 1:
                        LearningTour = _d.sent();
                        this.learningPathMetas = LearningTour.learning_path_metas;
                        this.userId = LearningTour.user_id;
                        _a = this;
                        return [4 /*yield*/, this.createAndGetPracticeList(this.exerciseMetaId, this.userId)];
                    case 2:
                        _a.exerciseList = _d.sent();
                        this.exerciseList.exercise = this.exerciseList.exercise.map(function (item) {
                            _this.getSimulationPhase(item.exerciseMetaId).then(function (res) {
                                item.phaseNum = res ? res.length : 0;
                            });
                            return item;
                        });
                        return [4 /*yield*/, this.getLearningPathMetaId(this.exerciseList.learningPathId)];
                    case 3:
                        LearningPathMetaId = _d.sent();
                        this.learningPathMetaId = LearningPathMetaId.data;
                        _b = this;
                        return [4 /*yield*/, this.commonService.getCustomLockDate(this.learningPathMetaId)];
                    case 4:
                        _b.learningPath = _d.sent();
                        return [4 /*yield*/, this.getlearningInit(this.exerciseList.practiceMetaId, this.exerciseList.exercise)];
                    case 5:
                        _d.sent();
                        return [4 /*yield*/, this.getListItemExtends(this.exerciseList.exercise)];
                    case 6:
                        _d.sent();
                        return [4 /*yield*/, this.getProgress(this.learningPathMetaId)];
                    case 7:
                        progerss = _d.sent();
                        //向LMS传递进度
                        if (localStorage.getItem('source_env') === 'LMS_SCORM') {
                            this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', progerss[0].progressList[0].progress, 'data');
                        }
                        this.currentIndex = progerss[0]['progressList'][0]['currentItemIndex'] == 4 && progerss[0]['progressList'][0]['progress'] == 100 ? 5 : progerss[0]['progressList'][0]['currentItemIndex'];
                        _c = this;
                        return [4 /*yield*/, this.getPracticeMoments(this.exerciseMetaId, this.userId)];
                    case 8:
                        _c.moments = _d.sent();
                        $('#userIdContainer').val(this.userId);
                        $('#learningPathMetaIdContainer').val(this.learningPathMetaId);
                        this.learningPathId = this.exerciseList.learningPathId;
                        this.practiceList = this.exerciseList.exercise;
                        this.practiceId = this.exerciseList.id;
                        this.approachTheme.colorSystem = 'dark';
                        this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
                        this.approachTheme.currentIndex = this.currentIndex - 2;
                        this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
                        this.approachTheme.btnTxt = '开启能力考核';
                        this.practiceList[0].momentsList = this.handleMomentsList(this.moments);
                        //增加学习断点
                        return [4 /*yield*/, this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': this.platformLocation['location']['href'], 'projectId': localStorage.getItem('projectId') ? localStorage.getItem('projectId') : null }).then()];
                    case 9:
                        //增加学习断点
                        _d.sent();
                        this.commonService.setCustomLockDate(this.learningPath, Date());
                        this.isCustomLock = this.learningPath.subItems[3].isLock;
                        this.isShowApproach = true;
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CaseExecutiveListComponent.prototype.linkToError = function (status) {
        var link = ['error', status];
        this.router.navigate(link);
    };
    CaseExecutiveListComponent.prototype.createAndGetPracticeList = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/createAndGet'
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/createAndGet?userId=' + userId
        }).toPromise();
    };
    CaseExecutiveListComponent.prototype.getPracticeMoments = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/achievement/list'
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/achievement/list?userId=' + userId
        }).toPromise();
    };
    //获取learningpathid
    CaseExecutiveListComponent.prototype.getLearningPathMetaId = function (learningPathId) {
        return this.apiService.ajax({
            'type': 'get',
            // 'url': this.commonService.getOrigin() + '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
            'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
        }).toPromise();
    };
    CaseExecutiveListComponent.prototype.getCardIdWithUserId = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/currentCard',
        }).toPromise();
    };
    //获取情景模拟的阶段数
    CaseExecutiveListComponent.prototype.getSimulationPhase = function (simulationId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': "/sim/v1/simulation/" + simulationId + "/phase_config"
        }).toPromise();
    };
    CaseExecutiveListComponent.prototype.handleMomentsList = function (moments) {
        var arr = [];
        if (moments) {
            moments.forEach(function (v) {
                arr.push('moments' + v.yySimulationAchievementMeta.exerciseMetaId + '-' + v.yySimulationAchievementMeta.id);
            });
        }
        return arr;
    };
    CaseExecutiveListComponent.prototype.getlearningInit = function (practiceMetaId, practiceList) {
        var _this = this;
        var temp = true;
        this.abilityConfig.getOnceinoByPracticeMetaId(practiceMetaId).subscribe(function (result) {
            _this.finishStatus = result == 1 ? true : false;
            for (var i = 0; i <= practiceList.length - 1; i++) {
                if (practiceList[i].status != 2) {
                    temp = false;
                }
            }
            _this.finished = temp;
            _this.getUserLearningPathMetaId();
        });
    };
    CaseExecutiveListComponent.prototype.getListItemExtends = function (practiceList) {
        //loadconfig
        this.apiService
            .loadConfig('./assets/config/practiceList.json')
            .subscribe(function (result) {
            practiceList.forEach(function (item, index) {
                console.log(result[item.title]);
                if (result[item.title]) {
                    item['extends'] = result[item.title];
                }
            });
        });
    };
    CaseExecutiveListComponent.prototype.getLearningTour = function () {
        return this.apiService.ajax({
            type: 'get',
            url: '/sr/learningtournew'
        }).toPromise();
    };
    //获取用户学习 metaid and version
    CaseExecutiveListComponent.prototype.getUserLearningPathMetaId = function () {
        var that = this;
        that.getOrCreateLearningPath(String(that.learningPathMetaId)).then(function (result) {
            that.learningPath = result;
            that.learningPathSubItems = result.subItems;
            if (result.lock !== 3) {
                that.goPostSurveyFlag = true;
            }
            else {
                that.goPostSurveyFlag = false;
            }
        }).then(function () {
            return that.getUserQuestionnaireInfo(that.learningPathMetaId).then(function (result) {
                return that.questionnaireInfo = result;
            });
        }).then(function () {
            console.log(that.isShowQuestionnaire);
            that.isShowQuestionnaire = that.questionnaireInfo && that.questionnaireInfo.length === 0 && that.learningPathSubItems.filter(function (d) { return d.type === 3; })[0].progress === 100 && that.learningPathSubItems.filter(function (d) { return d.type === 4; })[0].progress !== 100;
        });
    };
    CaseExecutiveListComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
    };
    CaseExecutiveListComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            backgroundColor: 'white',
        });
    };
    CaseExecutiveListComponent.prototype.goToNextStep = function (practiceItem) {
        var _this = this;
        if (this.learningPathMetaId) {
            var channel = document.getElementById('resource_route');
            var origin = channel.dataset.src === '' ? this.commonService.getOrigin() : 'https://m.transtalent.cn';
            var params = channel.dataset.src === '' ? '' : '&channelHost=' + this.commonService.getOrigin() + '/yyddi/';
            var href = '';
            if (this.learningPathMetaId === 201) {
                href = origin + '/simulation_cn/' + this.exerciseMetaId + '/index.html?learningPathMetaId=' + this.learningPathMetaId + '&exerciseMetaId=' + this.exerciseMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
            }
            else {
                href = origin + '/simulation/' + this.exerciseMetaId + '/index.html?learningPathMetaId=' + this.learningPathMetaId + '&exerciseMetaId=' + this.exerciseMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
            }
            this.platformLocation['location']['href'] = this.isOpenClass === 1 ? href + '&isShowBack=0' : this.type === 'huatek' ? href + '&type=huatek' : href + params;
        }
        else {
            this.getLearningPathMetaId(this.learningPathId).then(function () {
                _this.goToNextStep(practiceItem);
            });
        }
    };
    //展示难忘瞬间gallary
    CaseExecutiveListComponent.prototype.momentView = function (mlist, $event) {
        this.showMoment = true;
        this.momentList = mlist;
        $event.stopPropagation();
    };
    //关闭难忘瞬间gallary
    CaseExecutiveListComponent.prototype.momentExit = function () {
        this.showMoment = false;
    };
    CaseExecutiveListComponent.prototype.goToPostSurvey = function () {
        if (this.type === 'huatek') {
            this.commonService.sendPostMessage(1, 'goPostSurvey');
            return;
        }
        else {
            if (this.lock) {
                this.showToast();
                return;
            }
            this.apiService
                .ajax({
                type: 'GET',
                url: '/sr/exposeoutapi/setAbilitySession/' +
                    this.learningPathMetaId +
                    '/4',
            })
                .subscribe(function (result) {
            });
            this.commonService.learningPortEventLogByCandy({ 'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem('userId') }).then();
            var link = ['ability-survey', this.learningPathMetaId, 2];
            this.router.navigate(link);
        }
    };
    CaseExecutiveListComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    CaseExecutiveListComponent.prototype.finish = function () {
        if (this.finishStatus) {
            return;
        }
        else {
            this.abilityConfig
                .setOnceinoByPracticeMetaId(this.practiceMetaId)
                .subscribe();
            var link = ['learning-map'];
            this.router.navigate(link);
        }
    };
    CaseExecutiveListComponent.prototype.close = function () {
        var link = ['learning-path', this.learningPathMetaId];
        this.router.navigate(link);
    };
    CaseExecutiveListComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    //查询用户相应能力满意度
    CaseExecutiveListComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    return CaseExecutiveListComponent;
}());
export { CaseExecutiveListComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-executive-list/case-practice-executive-list.component.ts.pre-build-optimizer.js